import { Col, Row, Typography } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { fCurrencySymbol } from "../../helper/formatNumber";
import { CheckCircleOutlined, SmileFilled } from "@ant-design/icons";
const { Paragraph } = Typography;
const locale = require("react-redux-i18n").I18n;
function BoxScanQrCodeLoas({
  isQrcode,
  account,
  rate,
  paymentSelected,
  amount,
  bankDetail,
}) {
  const profileCountry = useSelector((state) => state.user.profileCountry);
  //   isQrcode={prompt}
  //   account={props.account}
  //   rate={props.rate}
  //   paymentSelected={props.paymentSelected}
  return (
    <Row className="container-scan-qrcode d-flex" gutter={[30, 30]}>
      <Col xs={24} md={8}>
        <div className="box-scan-qrcode">
          {/* <div className="head-qrcode d-flex justify-content-center">
            <img
              src="/assets/images/icons/iux-logo-outline.png"
              alt="iux-logo-outline"
              width={32}
            />
          </div> */}
          <div className="detail-qrcode ">
            <img
              src={"/assets/images/qrcode/IUX.png"}
              alt="watermark"
              className="logo-qr-iux "
              // width="100%"
            />
            <img src={isQrcode} alt="qr code" width="100%" />
          </div>
        </div>
      </Col>
      <Col xs={24} md={16}>
        <div className="fs-14" style={{ fontWeight: 500 }}>
          {/* {bankDetail} */}
          {bankDetail?.bank}
        </div>
        <div className="mt-2">
          <span className="text-gray">
            {" "}
            {locale.t("withdraw_info.account.name")}:
          </span>{" "}
          <b>{bankDetail?.owner}</b>
        </div>
        <div className="mt-2 d-flex">
          <span className="text-gray">
            {locale.t("withdraw_info.account.number")}:
          </span>
          &nbsp;
          <Paragraph
            className="m-0 fw-700"
            copyable={{
              icon: [
                <span className="cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M5 2H9.73333C11.2268 2 11.9735 2 12.544 2.29065C13.0457 2.54631 13.4537 2.95426 13.7094 3.45603C14 4.02646 14 4.77319 14 6.26667V11M4.13333 14H9.53333C10.2801 14 10.6534 14 10.9387 13.8547C11.1895 13.7268 11.3935 13.5229 11.5213 13.272C11.6667 12.9868 11.6667 12.6134 11.6667 11.8667V6.46667C11.6667 5.71993 11.6667 5.34656 11.5213 5.06135C11.3935 4.81046 11.1895 4.60649 10.9387 4.47866C10.6534 4.33333 10.2801 4.33333 9.53333 4.33333H4.13333C3.3866 4.33333 3.01323 4.33333 2.72801 4.47866C2.47713 4.60649 2.27316 4.81046 2.14532 5.06135C2 5.34656 2 5.71993 2 6.46667V11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27316 13.5229 2.47713 13.7268 2.72801 13.8547C3.01323 14 3.3866 14 4.13333 14Z"
                      stroke="#1CB894"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>,
                <CheckCircleOutlined />,
              ],
              tooltips: ["Copy here", "Copied!!"],
            }}
          >
            {bankDetail?.account_number}
          </Paragraph>
        </div>
        <div className="mt-2">
          <span className="text-gray">
            {locale.t("deposit_step.second_step.description")}:
          </span>
          &nbsp;
          <b>
            {fCurrencySymbol(amount)}&nbsp;
            {profileCountry?.symbol}
          </b>
        </div>
        {/* <div className="mt-2 d-flex">
          <span className="text-gray"> To account:&nbsp;</span>
          <div>
            {account?.platform}&nbsp;
            {account?.account_number}
            &nbsp; ({account?.account_group?.display})
          </div>
        </div>
        <div className="mt-2">
          <span className="text-gray"> Deposit by:</span>{" "}
          {paymentSelected?.name}
        </div>
        <div className="mt-2">
          <span className="text-gray"> Currency rate: </span>
          <span>
            {rate?.toFixed(2)}&nbsp;{profileCountry?.symbol}
          </span>
        </div> 
        <div className="mt-2">
          <span className="text-gray"> Fee:</span> 0.00 {profileCountry?.symbol}
        </div>*/}
        <div className="mt-2">
          <span className="text-gray">
            {" "}
            {locale.t("deposit_step.second_step.you_receive")}:
          </span>{" "}
          <b>
            {`${(amount / rate).toFixed(2)}
                USD`}
          </b>
        </div>
      </Col>
    </Row>
  );
}

export default BoxScanQrCodeLoas;
